// Header.js
import * as React from "react";
import Box from "@mui/material/Box";
import "assets/styles.css";
import { useNavigate } from "react-router-dom";
import teamCodeHashmap from "utils/teamCodeHashmap";
import { useGender } from "contexts/GenderContext";

export default function Header({
  teamName,
  rank,
  points,
  confederationName,
  confederationCode,
}) {
  const navigate = useNavigate();
  const { selectedGender, setSelectedGender } = useGender();
  const isMen = selectedGender === "Men";

  const getFlagImagePath = (teamName) => {
    const teamEntry = teamCodeHashmap[teamName.toLowerCase()];

    if (!teamEntry) {
      console.error(`Flag not found for team: ${teamName}`);
      return "";
    }

    const teamCode = Object.keys(teamEntry)[0];

    const flagPath = `/Retangular_flags/flag_${teamCode.toLowerCase()}.png`;

    return flagPath;
  };

  const handleToggleGender = () => {
    const newGender = isMen ? "Women" : "Men";
    setSelectedGender(newGender);
    navigate(`/team-details-live/${newGender.toLowerCase()}/${teamName}`);
  };

  return (
    <Box className="OuterHeader">
      <Box className="HeaderLeft">
        <img className={"Flag"} src={getFlagImagePath(teamName)} alt={"Flag"} />
        <Box className="Header1">
        <Box className="Header1Box1">
          <div className="Header1Box1Typo1">{teamName}</div>
          <div className="Header1Box1Typo2">|</div>
          <div className="Header1Box1Typo3">{isMen ? "Men" : "Women"}</div>
        </Box>
        <Box className="Header1Box2">
          <Box className="Header1Box2Frame1">
            <div className="Header1Box2Frame1Typo">{`${confederationName}`}</div>
          </Box>
          <Box className="Header1Box2Frame2">
            <div className="Header1Box2Frame2Typo">{`${confederationCode}`}</div>
          </Box>
        </Box>
        <div
          className="GenderTypo"
          onClick={handleToggleGender}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") {
              handleToggleGender();
            }
          }}
          role="button"
          tabIndex={0}
          style={{ cursor: "pointer" }}
        >
          {`See ${isMen ? "Women’s" : "Men’s"} Team`}
        </div>
        </Box>
      </Box>
      <Box className="Header2">
        <div className="RankTypo">#{rank}</div>
        <div className="PointsTypo">{points} Points</div>
      </Box>
    </Box>
  );
}
